import { isBrowser } from '@backyard-ui/utils';
import { type InsightsClient } from 'instantsearch.js/es/types/insights';
import aa from 'search-insights';

import { API_KEY, APP_ID } from '../search-client';

if (isBrowser) {
  aa('init', {
    appId: APP_ID,
    apiKey: API_KEY,
    useCookie: true,
  });
}

const noopInsightsClient = (() => undefined) as InsightsClient;

const insightsConfig = {
  insightsClient: isBrowser ? (aa as InsightsClient) : noopInsightsClient,
};

export default insightsConfig;
